import {ButtonProps, ButtonType} from './types';
import * as React from 'react';
import '@sass/_button.scss';

const Button = (props: ButtonProps) => {
  const {
    id,
    onClick,
    href,
    disabled,
    role,
    ariaLabel,
    text,
    className,
    type = ButtonType.PRIMARY,
    large,
    target,
    rel,
    ariaExpanded,
    ariaControls,
  } = props;

  const classes = `button button--${type} ${large ? 'button--large' : ''}`;

  const content = <div className="button__content">{text}</div>;

  return (
    <div className={`button-wrapper ${className || ''}`}>
      {href ? (
        <a
          id={id}
          href={href}
          className={classes}
          aria-label={ariaLabel}
          target={target}
          rel={rel}
        >
          {content}
        </a>
      ) : (
        <button
          id={id}
          onClick={onClick}
          className={classes}
          disabled={disabled}
          role={role}
          aria-label={ariaLabel}
          aria-expanded={ariaExpanded}
          aria-controls={ariaControls}
        >
          {content}
        </button>
      )}
    </div>
  );
};

export default Button;